module.exports = __webpack_public_path__ + "static/media/all-card_grey_big.66676a07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/icons/all-card_grey_big.png
// module id = ./src/assets/media/icons/all-card_grey_big.png
// module chunks = 16